export const fetchCollaboratorsCalendar = data => ({
  type: "FETCH_COLLABORATORS_CALENDAR",
  payload: data
});

export const setSelectedCollaboratorName = name => ({
  type: "SET_SELECTED_COLLABORATOR_NAME",
  name
});

export const initCollaboratorsSynthesis = data => ({
  type: "INIT_COLLABORATOR_SYNTHESIS",
  payload: data
});

export const fetchCollaboratorsSynthesis = data => ({
  type: "FETCH_COLLABORATORS_SYNTHESIS",
  payload: data
});

export const setCollaboratorCalendarTab = item => {
  return {
    type: "SET_COLLABORATOR_CALENDAR_TAB",
    item
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/collaborator-calendar.js